import postRobot, { HandlerType } from 'post-robot';
import { ROOT_DOMAIN } from 'common/environment';
import { error } from 'common/errors';
/* START GENAI@GHCOPILOT */
import { markEnd, markStart } from 'common/instrumentation';
import { isObject } from 'common/type-guards';
import { SdkMessageType } from 'types/messages/post-robot';
import { isDpaIdPresent, queryParam } from './flags';

markStart('vsb_orch_communicator_iframe_load');

const parentUrl = encodeURIComponent(window.location.origin);
const iframe = document.createElement('iframe');
//eslint-disable-next-line
console.log('queryParam? >> ', queryParam);
// prettier-ignore
const query = [
  isDpaIdPresent ? `dpaId=${queryParam}` : null,
  `parentUrl=${parentUrl}`
]
  .filter(Boolean)
  .join('&');

iframe.id = 'vsb-system-frame';
iframe.src = `${ROOT_DOMAIN}/checkout-widget/orch-communicator?${query}`;
iframe.style.position = 'absolute';
iframe.style.height = '0';
iframe.style.width = '0';
iframe.style.border = 'none';
// START GENAI@CLINE
// Security: Add sandbox attributes to prevent malicious code execution
iframe.sandbox.add('allow-scripts');
iframe.sandbox.add('allow-forms');

iframe.allow = [`payment ${ROOT_DOMAIN}`, 'publickey-credentials-get'].filter(Boolean).join('; ');
// END GENAI@CLINE
iframe.onload = () => {
  markEnd('vsb_orch_communicator_iframe_load');
};
/* END GENAI@GHCOPILOT */

document.body.appendChild(iframe);

/**
 * START GENAI@GHCOPILOT
 * Sends a message to the communicator iframe and returns a promise that resolves with the response.
 *
 * @param name - The name of the message to send.
 * @param data - The data to send along with the message (optional).
 * @param timeout - The timeout value for the request in milliseconds (default: 50000).
 * @returns A promise that resolves with the response data.
 * @throws If the request times out or encounters an error.
 * END GENAI@GHCOPILOT
 */
export async function sendToOrchCommunicator<ResponseData extends object = object>(
  name: SdkMessageType,
  data?: object,
  timeout = 50000
) {
  return postRobot
    .send<ResponseData>(iframe.contentWindow, name, data, {
      domain: ROOT_DOMAIN,
      timeout
    })
    .then(res => {
      return res;
    })
    .catch((err: unknown) => {
      if (isObject(err) && !('reason' in err)) {
        throw error('REQUEST_TIMEOUT', err.toString());
      }

      throw err;
    });
}

/**
 * START GENAI@GHCOPILOT
 * Listens to the Orch Communicator for a specific event and executes the provided callback function.
 * @param name - The name of the event to listen for.
 * @param cb - The callback function to execute when the event is triggered.
 * @returns A Promise that resolves when the event is successfully registered.
 * END GENAI@GHCOPILOT
 */
export async function listenToOrchCommunicator(name: string, cb: HandlerType) {
  postRobot.on(name, { window: iframe.contentWindow }, cb);
}
